let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("3Z5D1")).then(() => parcelRequire('do1p6'));